import { useSelector } from 'react-redux'
import { messagesSelectors } from 'store/messages'
import { useTranslation } from 'react-i18next'
import { formatISODate } from 'utils/dates'
import { OdinButton } from '@/components/ui/odin/odin-button'
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from '@/components/ui/card'
import { useModal } from 'providers/ModalProvider'
import { CloseTicketModal } from 'components/modals/CloseTicketModal'

export const TicketInfoCard = () => {
  const { t } = useTranslation()
  const { openModal } = useModal()
  const isInOperatorMode = useSelector(messagesSelectors.currentChatIsInOperatorMode)
  const ticket = useSelector(messagesSelectors.currentChatTicket)
  const disableFieldsTicketClosed = useSelector(messagesSelectors.disableFieldsTicketClosed)

  if (!isInOperatorMode || !ticket) {
    return null
  }

  return (
    <div className="p-0.5">
      <Card size="sm" className="w-full shadow-none">
        <CardHeader>
          <CardTitle>{t('youOpenedATicket')}</CardTitle>
          <CardDescription>{formatISODate(ticket.createdAt)}</CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-1">
          <div className="text-sm font-medium">{ticket.title}</div>
          {ticket.description && <div className="line-clamp-2 text-sm text-muted-foreground">{ticket.description}</div>}
        </CardContent>
        <CardFooter>
          <OdinButton
            variant="outline"
            size="sm"
            disabled={disableFieldsTicketClosed}
            onClick={() => openModal(<CloseTicketModal ticketId={ticket._id} />)}
            className="w-full"
          >
            {disableFieldsTicketClosed ? t('closedTicket') : t('closeTicket')}
          </OdinButton>
        </CardFooter>
      </Card>
    </div>
  )
}
